import Reveal from "@/components/landing/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq({ t }) {
  return (
    <section className="px-5 sm:px-10 lg:px-16 py-20 sm:py-28" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <Reveal className="text-center mb-12">
          <h2 className="font-serif tracking-tight text-3xl sm:text-4xl leading-tight">
            {t.faqTitle} <em className="text-sage">{t.faqAccent}</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {t.faq.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-white border border-line rounded-2xl px-6 data-[state=open]:border-sage/40 transition-colors"
                data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-lg py-5 hover:no-underline hover:text-sage transition-colors">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-stonemute leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
